import { BuyGuideVendorContactList } from '../../../components/BuyGuide';

export function BuyGuideVendorContacts() {
  return <BuyGuideVendorContactList />;
}
